(function () {
    'use strict';

    angular.module('app').factory('API', API);

    API.$inject = ['$http', '$rootScope', '$location', 'NotifyService', '$translate', '$filter', 'LANGS', '$STORAGE_KEY', '$uibModalStack'];

    function API($http, $rootScope, $location, NotifyService, $translate, $filter, LANGS, $STORAGE_KEY, $uibModalStack) {
        var service = {};
        /**
         * This callback type is called `requestCallback` and is displayed as a global symbol.
         *
         * @callback requestCallback
         * @param {boolean} success
         * @param {Object} data
         */
        service.GET_List = [];

        $rootScope.$on('user-logout', function () {
            service.GET_List = [];
        });

        // $rootScope.appConfig = {};
        $rootScope.appConfig = appConfig;
        service.useApiExternal = false;
        service.apiBase = $rootScope.appConfig.apiBase;
        try {
            if (localStorage && localStorage.apiBase) {
                service.apiBase = localStorage.apiBase;
                service.useApiExternal = true;
            }

        } catch (e) {
        }
        // if ($location.host().indexOf('test') != -1 || $location.host().indexOf('localhost') != -1)
        // $rootScope.appConfig = appConfig.dev;
        // else
        // $rootScope.appConfig = appConfig.prod;
        service.apiVersion = $rootScope.appConfig.base_version;

        service.apiToken = '';
        service.setApiToken = function (token) {
            service.apiToken = token;
        };
        service.getApiToken = function () {
            return service.apiToken;
        };

        /**
         * Make Header
         *
         * @param {boolean} ignoreToken
         * @param {String} language
         * @returns {{'Accept-Language', 'X-Application-Type': string, 'Content-Type': string}}
         */
        service.makeHeader = function (ignoreToken, language) {
            var lang;

            if (language) {
                lang = language;
            } else {
                try {
                    var NG_TRANSLATE_LANG_KEY = localStorage.getItem($STORAGE_KEY);//localStorageService.get('_t');
                    if (NG_TRANSLATE_LANG_KEY)
                        lang = NG_TRANSLATE_LANG_KEY.replace(/\"/g, '');
                    else
                        lang = getPrefferedLang(LANGS, $translate.preferredLanguage());

                } catch (e) {
                    lang = getPrefferedLang(LANGS, $translate.preferredLanguage());
                }
            }

            var header = {
                'X-Application-Type': 'web',
                'Content-Type': 'application/json',
                'Accept-Language': lang //navigator.language
            };

            console.log('HEADERS =============>', header);
            var apiToken = service.getApiToken();
            if (apiToken && !ignoreToken) {
                header.Authorization = 'bearer ' + apiToken;
            }

            return header;
        };

        service.isRequestInQuery = function (pending_requests, req) {
            for (var i in pending_requests)
                if (pending_requests[i].url === req.url)
                    return true;

            return false;
        };

        /**
         * Main function for send any request to server api
         * @param {{headers: {'Accept-Language', 'X-Application-Type': string, 'Content-Type': string}, method: string, url: string}} req
         * @param {string} req.method
         * @param {number} req.timeout
         * @param {boolean} req.slow_request
         * @param {Object} req.data
         * @param {Object} req.headers
         * @param {requestCallback} callback
         * @param {Object} config
         */
        service.request = function (req, callback, config) {
            // console.info("API Request", JSON.stringify(req));
            console.info('API Request', req);
            NotifyService.clearFlashMessage(false);

            // Store GET request as promise
            var promise = {};
            //var canceller = $q.defer();

            req.timeout = 90000;
            if (req.slow_request) {
                delete req.slow_request;
                req.timeout = 540000;
            } else if (req.data && req.data.slow_request) {
                delete req.data.slow_request;
                req.timeout = 540000;
            }

            if (!!config && typeof config === 'object') {
                req = Object.assign(req, config);
            }

            if (!service.isRequestInQuery($http.pendingRequests, req.url)) {

                var startTime = new Date();
                // console.info("SENDING API Request", req);
                if (req.method == 'GET') {
                    if (service.GET_List[req.url]) {
                        promise = service.GET_List[req.url];
                    } else {
                        promise = $http(req);
                        service.GET_List[req.url] = promise;
                    }
                } else {
                    promise = $http(req);
                }

                promise.then(
                    function successCallback(response) {
                        var endTime = new Date();
                        delete service.GET_List[response.config.url];

                        // console.info("API Response OK", JSON.stringify(response.data));
                        console.info('API Response OK' + ' (processed in ' + (endTime - startTime) / 1000 + ' sec)', response.data);
                        if (callback) {
                            callback(true, response.data);
                        }

                    },
                    function errorCallback(response) {
                        var endTime = new Date();
                        delete service.GET_List[response.config.url];
                        var data = response.data;
                        if (data && data.code && data.message) {
                            console.warn('API Response Error' + ' (processed in ' + (endTime - startTime) / 1000 + ' sec)', response);
                            if (data.code == 3) {
                                service.setApiToken('');
                            }
                            $rootScope.$broadcast('api_response_error', response);
                        } else {
                            console.error('API Response Error' + ' (processed in ' + (endTime - startTime) / 1000 + ' sec)', response);
                            if (response.status && response.status == 401) {
                                $uibModalStack.dismissAll();
                                service.setApiToken('');
                                $rootScope.redirectToSignIn(true);
                            } else {
                                if (data && data.detail) {
                                    data = {
                                        code: 500,
                                        message: data.detail
                                    };
                                } else {
                                    data = {
                                        code: 500,
                                        message: $filter('translate')('Can\'t connect to server or internal server error.')
                                    };
                                }
                            }
                        }

                        if (!$location.$$search && !$location.$$search.tab) {
                            NotifyService.ErrorAPI(data);
                        }

                        if (typeof callback === 'function')
                            callback(false, data);
                    });
            }
        };

        /**
         *  REST GET
         *  @param {string} url
         *  @param {requestCallback} callback - The callback that handles the response.
         *  @param {boolean} slow_request - The request will be sent with 9 minutes timeout
         *  @param {Object} config
         *  @param {string} language
         */
        service.get = function (url, callback, slow_request, config, language) {
            if (slow_request === undefined) {
                slow_request = false;
            }
            var req = {
                method: 'GET',
                url: service.apiBase + url,
                headers: service.makeHeader(false, language)
            };
            if (slow_request) {
                req.slow_request = true;
            }

            service.request(req, callback, config);
        };

        /**
         *  REST POST
         *  @param {string} url
         *  @param {object} post_data
         *  @param {requestCallback} callback - The callback that handles the response.
         */
        service.post = function (url, post_data, callback) {
            var req = {
                method: 'POST',
                url: service.apiBase + url,
                headers: service.makeHeader(),
                data: post_data
            };

            service.request(req, callback);
        };

        /**
         *  REST POST IMAGE
         *  @param {string} url
         *  @param {object} post_data
         *  @param {requestCallback} callback - The callback that handles the response.
         */
        service.postImage = function (url, post_data, callback) {
            var req = {
                method: 'POST',
                url: service.apiBase + url,
                headers: service.makeHeader(),
                slow_request: true,
                data: post_data
            };

            req.headers['Content-Type'] = post_data.indexOf('image/png') > -1 ? 'image/png' : 'image/jpeg';
            req.headers['Content-Encoding'] = 'base64';
            service.request(req, callback);
        };

        /**
         * REST PATCH
         * @param {string} url
         * @param {object} post_data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.patch = function (url, post_data, callback) {
            var req = {
                method: 'PATCH',
                url: service.apiBase + url,
                headers: service.makeHeader(),
                data: post_data
            };
            service.request(req, callback);
        };

        /**
         * REST DELETE
         * @param {string} url
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.del = function (url, callback) {
            var req = {
                method: 'DELETE',
                url: service.apiBase + url,
                headers: service.makeHeader()
            };
            service.request(req, callback);
        };
        /**
         * REST DELETE
         * @param {string} url
         * @param {object} post_data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.delete = function (url, post_data, callback) {
            var req = {
                method: 'DELETE',
                url: service.apiBase + url,
                headers: service.makeHeader(),
                data: post_data
            };
            service.request(req, callback);
        };

        return service;

    }
})();
